// extracted by mini-css-extract-plugin
export default {"stick":"style_stick__RNLGR","text":"style_text__6OTj1","spinner":"style_spinner__yfQn+","actions":"style_actions__6vuN3"};